// store/ui.ts
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { Task } from '@/shared/types/task';

export interface BottomPill {
  id: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

interface UIState {
  isMenuOpen: boolean;
  pageBackgroundColor: string;
  headerBottomContent: React.ReactNode | null;
  bottomPills: BottomPill[];
  meetingTasks: Task[];
  dayTasks: Task[];
  isCalendarOpen: boolean; // Добавляем состояние календаря
  /** Панель массовых действий над таблицей задач открыта (выбрана хотя бы
   *  одна строка) — плавающая кнопка «Создать» на неё пока не должна лезть. */
  isBulkActionsBarOpen: boolean;
  /** Поверх фоновой страницы открыт оверлей детальной задачи/проекта
   *  (см. AppRouter). Фон остаётся смонтированным, поэтому его плавающие
   *  элементы (FAB «Создать»), портящиеся в body, должны сами скрыться. */
  isDetailOverlayOpen: boolean;

  setBottomPills: (pills: BottomPill[]) => void;
  clearBottomPills: () => void;
  toggleMenu: () => void;
  openMenu: () => void;
  closeMenu: () => void;
  setPageBackgroundColor: (color: string) => void;
  setHeaderBottomContent: (content: React.ReactNode | null) => void;
  setMeetingTasks: (tasks: Task[]) => void;
  setDayTasks: (tasks: Task[]) => void;
  setIsCalendarOpen: (isOpen: boolean) => void; // Добавляем функцию
  setIsBulkActionsBarOpen: (isOpen: boolean) => void;
  setIsDetailOverlayOpen: (isOpen: boolean) => void;
}

export const useUIStore = create<UIState>()(
  devtools(
    (set) => ({
      isMenuOpen: false,
      pageBackgroundColor: '#F9FAFB',
      headerBottomContent: null,
      bottomPills: [],
      meetingTasks: [],
      dayTasks: [],
      isCalendarOpen: false, // По умолчанию закрыт
      isBulkActionsBarOpen: false,
      isDetailOverlayOpen: false,

      toggleMenu: () =>
        set((state) => ({
          isMenuOpen: !state.isMenuOpen,
        })),

      setBottomPills: (pills) => set({ bottomPills: pills }),
      clearBottomPills: () => set({ bottomPills: [] }),

      openMenu: () => set({ isMenuOpen: true }),

      closeMenu: () => set({ isMenuOpen: false }),

      setPageBackgroundColor: (color: string) =>
        set({ pageBackgroundColor: color }),

      setHeaderBottomContent: (content: React.ReactNode | null) =>
        set({ headerBottomContent: content }),

      setMeetingTasks: (tasks) => set({ meetingTasks: tasks }),
      setDayTasks: (tasks) => set({ dayTasks: tasks }),

      setIsCalendarOpen: (isOpen: boolean) => set({ isCalendarOpen: isOpen }),
      setIsBulkActionsBarOpen: (isOpen: boolean) =>
        set({ isBulkActionsBarOpen: isOpen }),
      setIsDetailOverlayOpen: (isOpen: boolean) =>
        set({ isDetailOverlayOpen: isOpen }),
    }),
    { name: 'UI Store' }
  )
);
